<template>
  <div
    class="base-input"
    :class="{ error: hasValidationError && !loading }"
    :style="{ width }"
  >
    <label
      @click="() => !readonly && $refs.input.focus()"
      v-if="label && readonly"
      :class="['input__label', { readonly }]"
    >
      {{ label }}
    </label>

    <svgicon v-if="icon" :icon="icon" width="16px" class="icon" />

    <input
      :autocomplete="autocomplete ? 'on' : 'off'"
      ref="input"
      :name="name"
      v-model="inputValue"
      :placeholder="readonly ? '-' : placeholder"
      class="input__field"
      :readonly="readonly"
      :disabled="disabled || loading"
      :maxlength="usedMask.mask.length || limitMaxLength"
      @blur="handleBlur"
      @focus="$emit('focus')"
      @input="handleInput"
      @keydown="keydown"
      @keyup="keyup"
      @keypress="keypress"
      @paste="paste"
      :style="icon ? 'padding-left: 37px' : null"
    />
    <img
      class="loader_img"
      v-if="serverValidationPending"
      src="/img/Loader.gif"
    />
    <slot v-if="hasValidationError && !serverValidationPending" />
  </div>
</template>

<script>
import Base from "./Base/Base";
import {replacePointOnComma} from "@/utils/filters/stringFilters";

export default {
  name: "vtext",
  extends: Base,
  props: {
    icon: String,
  },
  methods: {
    handleBlur() {
      this.$emit("blur");
      this.validate();
    },
    focus() {
      this.$refs.input.focus();
    },
    handleInput({ target }) {
      if (this.type === "currency" && target.value) {
        this.inputValue = replacePointOnComma(target.value);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.loader_img {
  width: 15px;
  position: absolute;
  bottom: 32%;
  right: 10px;
}



.icon {
  position: absolute;
  left: 12px;
  top: 16px;

  @media screen and (max-width:1500px) {
    top: 14px;
    width: 13px !important;
    left: 16px;
  }
}
</style>
